import $ from 'jquery';
import init from '../init.js';
import cardHover from '../enhancements/hoverEffect';

export default function caseStudiesPage() {
    const $caseStudiesIndex = $('.case-studies-index');

	function showMore(e) {
        e.preventDefault();
		$caseStudiesIndex.children('.case-studies-index_more').addClass('-loading');

        const page = $(this).children('a').attr('href').split('/projects/')[1];
        $.get(`ajax/case-studies/${page}`, '', function(r) {
            $caseStudiesIndex.children('.case-studies-index_more').remove();
            $caseStudiesIndex.append(r);
            const $newGroup = $caseStudiesIndex.children('.case-studies-index_group').last();
            init($newGroup[0]);
            $caseStudiesIndex.children('.case-studies-index_more').on('click', showMore);
            // cardHover($caseStudiesIndex, $newGroup);
        });
	}

    // function setHoverEffect($group) {
	// 	const $cards = $group.find('.card');
	// 	$cards.on('mouseover', function() {
	// 		$caseStudiesIndex.addClass('-card-hovered');
	// 	}).on('mouseout', function() {
	// 		$caseStudiesIndex.removeClass('-card-hovered');
	// 	});
    // }

    $caseStudiesIndex.children('.case-studies-index_more').on('click', showMore);
	// setHoverEffect($caseStudiesIndex.children('.case-studies-index_group'));

	// cardHover($caseStudiesIndex, $caseStudiesIndex.children('.case-studies-index_group'))
}



// WEBPACK FOOTER //
// ./source/scripts/pages/casestudy.js